import Loader from "react-loader-spinner";
import { useEffect, useState, Fragment, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button, Card, Col, Form, FormGroup, OverlayTrigger, Popover } from "react-bootstrap";
import { deleteProduct, getAllProductMainGroups, searchProducts, getProductGroups, updateAllProductsPrice, getAllProductTypes, getAllProductHolders } from "../store/api/GetAllProduct";
import { Check2Square, EyeFill, EyeSlashFill, FileEarmarkExcelFill, PencilSquare, Search } from "react-bootstrap-icons";
import { setDialog } from "../store/api/Modals";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import BihamtaTable from "../../Components/BihamtaTable";
import { useForm } from "react-hook-form";
import { exportToExcel, isWebApp, setErrorDialog } from "../../store/api/CommonFunctions";
import NewNumberInput from "../../Components/NewNumberInput";
const SearchProduct = () => {
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const { register, handleSubmit } = useForm();
    const { settings, filterData, mainPGList, pgList } = useSelector(state => {
        return {
            settings: state.SystemSettingsReducer.systemSettings,
            mainPGList: state.ProductReducer.productMainGroupList,
            pgList: state.ProductReducer.productGroupList,
            filterData: state.ProductReducer.productSearchFilters
        }
    });
    const settingNames = ['ProductGrouppingType', 'Product_ExtAttr1_Title', 'Product_ExtAttr2_Title'];
    const pgType = Array.isArray(settings ?? "") ? Number(settings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1) : 1;

    function search(data) {
        data.Skip = 0;
        dispatch(searchProducts(data));
    }
    const history = useHistory();

    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", style: { backgroundColor: "gray" } },
        { colTitle: "کد کالا", colName: "KalaCode", showInMobile: true },
        { colTitle: "مارک کالا", colName: "HolderName", showInMobile: true, showCondition: () => pgType === 0 },
        { colTitle: (pgType === 1 ? "نام کالا" : "نوع کالا"), colName: "Name", showInMobile: true },
        { colTitle: "مدل کالا", colName: "Model", showInMobile: true },
        { colTitle: "آدرس در انبار", colName: "SecondName" },
        { colTitle: "شرح کالا", colName: "Importer" },
        { colTitle: "کارخانه سازنده", colName: "Manufacturer" },
        { colTitle: settings?.find(s => s.SettingName === "Product_ExtAttr1_Title")?.SettingValue, colName: "ExtAttr1" },
        { colTitle: settings?.find(s => s.SettingName === "Product_ExtAttr2_Title")?.SettingValue, colName: "ExtAttr2" }
    ]
    const tableRowButtons = [
        {
            title: "حذف کالا", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف کالا',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteProduct(item.ID, search)
                }))
            }
        },
        {
            title: "نمایش کالا", type: "show", className: "group-Btn-smalll btn-success", onclick: (item) => showProduct(item.ID)
        }

    ]

    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function loadProductGroups(e) {
        const mgID = e.target.value;
        if (mgID === "") {
            return;
        }
        dispatch(getProductGroups(mgID));
    }
    function toExcel() {
        const url = "api/ProductAPI/SearchProducts";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("SearchProduct", searchArgs, url, "post", tableColes, () => setPending(false));
    }
    function showProduct(id) {
        history.push("/BaseInfo/AddEditProduct/" + id);
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-اطلاعات پایه";
        dispatch(getSystemSettings(settingNames));
        dispatch(getAllProductMainGroups());

    }, []);
    return (<div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
        <br />
        <Card>
            <Card.Header className="headerStyle">جستجوی کالاها</Card.Header>
            <Card.Body className="bodyStyle">
                <form onSubmit={handleSubmit(search)}>
                    <div className="row rowBorder" id="divFilters">
                        <div className="rowTitle">
                            فیلترهای جستجو
                            &nbsp;
                            {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                            {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                        </div>
                        <div className='form-group col-md-2'>
                            <input placeholder='کد کالا' type='text' className='form-control' name="Code" ref={register({})} defaultValue={filterData?.Code ?? ""}></input>
                        </div>
                        <div className='form-group col-md-2'>
                            <input placeholder='بارکد' type='text' className='form-control' name="BarCode" ref={register({})} defaultValue={filterData?.BarCode ?? ""}></input>
                        </div>
                        {pgType === 0 &&
                            <div className='form-group col-md-2'>
                                <input placeholder='مارک' type='text' className='form-control' name="HolderName" ref={register({})} defaultValue={filterData?.HolderName ?? ""}></input>
                            </div>
                        }
                        <div className="form-group col-md-2">
                            <input type='text' placeholder={pgType === 1 ? 'نام کالا' : "نوع کالا"} className="form-control" name="Name" ref={register({})} defaultValue={filterData?.Name ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder='مدل کالا' className="form-control" name="Model" ref={register({})} defaultValue={filterData?.Model ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <select className="form-control" name="ProductOrPart" ref={register({})} defaultValue={filterData?.ProductOrPart ?? ""} >
                                <option value="">کالا قطعه است یا محصول؟</option>
                                <option value={false}>محصول</option>
                                <option value={true}>قطعه</option>
                            </select>
                        </div>
                        {pgType !== 0 &&
                            <Fragment>
                                <Col md={2} className='form-group'>
                                    {mainPGList === "PENDING" &&
                                        <div className='form-control' style={{ textAlign: "center" }}>
                                            <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp; در حال بارگذاری لیست گروه های کالا
                                        </div>
                                    }
                                    {Array.isArray(mainPGList) &&
                                        <select className='form-control' name='MainGroupID' ref={register({})} onChange={loadProductGroups}>
                                            <option value="">گروه اصلی کالا را انتخاب کنید</option>
                                            {mainPGList.map((pg, i) => <option value={pg.MainGroupID} key={i}>{pg.MainGroupName}</option>)}
                                        </select>
                                    }
                                </Col>
                                <Col md={2} className='form-group'>
                                    {pgList === "PENDING" &&
                                        <div className='form-control' style={{ textAlign: "center" }}>
                                            <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp; در حال بارگذاری لیست گروه های کالا
                                        </div>
                                    }
                                    {Array.isArray(pgList) &&
                                        <select className='form-control' name='GroupID' ref={register({})}>
                                            <option value="">گروه فرعی کالا را انتخاب کنید</option>
                                            {pgList.map((pg, i) => <option value={pg.GroupID} key={i}>{pg.GroupName}</option>)}
                                        </select>
                                    }
                                </Col>
                                <Col md={2} className='form-group'>
                                    <input placeholder='نام محصول' type='text' className='form-control' name="ProductName" ref={register({})} defaultValue={filterData?.ProductName ?? ""}></input>
                                </Col>
                            </Fragment>
                        }
                        <div className="form-group col-md-2">
                            <input type='text' placeholder='آدرس در انبار' className="form-control" name="SecondName" ref={register({})} defaultValue={filterData?.SecondName ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder='شرح کالا' className="form-control" name="Importer" ref={register({})} defaultValue={filterData?.Importer ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder='کارخانه سازنده' className="form-control" name="Manufacturer" ref={register({})} defaultValue={filterData?.Manufacturer ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder={settings?.find(s => s.SettingName === "Product_ExtAttr1_Title")?.SettingValue} className="form-control" name="ExtAttr1" ref={register({})} defaultValue={filterData?.ExtAttr1 ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder={settings?.find(s => s.SettingName === "Product_ExtAttr2_Title")?.SettingValue} className="form-control" name="ExtAttr2" ref={register({})} defaultValue={filterData?.ExtAttr2 ?? ""} />
                        </div>
                        <Col md={2} className="form-group">
                            <select name="Take" ref={register({})} className="form-control" defaultValue={10}>
                                <option value={0}>تعداد در صفحه</option>
                                <option value={10}>ده ردیف</option>
                                <option value={20}>20 ردیف</option>
                                <option value={50}>50 ردیف</option>
                                <option value={100}>100 ردیف</option>
                                <option value={500}>500 ردیف</option>
                                <option value={1000}>1000 ردیف</option>
                            </select>
                        </Col>
                    </div>
                    <div>
                        <Button className="mt-2 group-Btn" type="submit"><Search size={15} />&nbsp;جستجوی کالا</Button>
                    </div>
                </form>
                {!pending ?
                    <div style={{ padding: 0, width: "100%", textAlign: "left" }}>
                        <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                    </div> :
                    <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                <BihamtaTable rowButtons={tableRowButtons} columns={tableColes} hasPaging={true} style={{ whiteSpace: isWebApp() ? "nowrap" : "normal" }} reducerName="ProductReducer" objectName="productListFull" searchMethod={(data) => dispatch(searchProducts(data))}
                    filterData={filterData} />
            </Card.Body>

        </Card>
    </div>
    );
}
export default SearchProduct;